import { useQuery } from '@tanstack/react-query';
import ApiService from '../../ApiService';

const fetchData = async () => {
    const { data } = await ApiService.getForecastingParameters();
    return data;
};

const useForecastingParameterListQuery = () => {
    return useQuery({
        queryKey: ['forecastingParameterList'],
        queryFn: () => fetchData(),
        staleTime: Infinity,
        enabled: true,
    });
};

export { useForecastingParameterListQuery };
